import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import { showToast } from 'vant';
import 'vant/es/toast/style';
import 'vant/es/overlay/style';
import 'vant/es/loading/style';
import logo from '../../assets/logo.png';
import wechatJsSdkMixin from '../../mixins/wechatJsSdkMixin';
import WechatOpenLaunchApp from '../../components/global/WechatOpenLaunchApp.vue';
import { isWeChatBrowser } from '../../utils/isWeChatBrowser';
import { navigateToDownloadPage } from '../../utils/navigateToDownloadPage';
import { ANDROID_QIPAO_PACKAGE, buildAndroidIntentLive, buildQipaoLiveScheme, buildWxLiveExtinfo } from '../../utils/liveAppLink';
export default {
  name: 'LiveDetail',
  components: {
    WechatOpenLaunchApp: WechatOpenLaunchApp
  },
  mixins: [wechatJsSdkMixin],
  data: function data() {
    return {
      logo: logo,
      /** 直播流名（App 分享链接口径，进 App 直播间的唯一标识） */
      streamName: '',
      /** 主播 user_id（分享链接 `uid` 参数）：进 App 后直播间页用它补拉主播资料 */
      hostUserId: '',
      /** 分享链接可选携带的标题 / 封面（App 端拼进 hash query） */
      shareTitle: '',
      shareCover: '',
      opening: false,
      _nativeOpenHandlers: null
    };
  },
  computed: {
    /**
     * 微信 wx-open-launch-app extinfo：`{ path: 'live/<stream_name>' }`，
     * App 端 handleWxExtinfo 归一为内部路由 `/live/<流名>`。
     * @returns {string}
     */
    wxLiveExtinfo: function wxLiveExtinfo() {
      return buildWxLiveExtinfo({
        streamName: this.streamName,
        uid: this.hostUserId
      });
    },
    /**
     * @returns {string}
     */
    titleText: function titleText() {
      return this.shareTitle || '正在直播';
    },
    /**
     * @returns {string}
     */
    coverUrl: function coverUrl() {
      return this.sanitizeUrl(this.shareCover);
    },
    heroStyle: function heroStyle() {
      if (this.coverUrl) {
        return {
          backgroundImage: "url('".concat(this.coverUrl, "')"),
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover'
        };
      }
      return null;
    }
  },
  methods: {
    sanitizeUrl: function sanitizeUrl(value) {
      return String(value || '').replace(/`/g, '').trim().replace(/^['"]+|['"]+$/g, '');
    },
    /**
     * 从 `?` 与 hash 上的 query 解析单键（与 circlePostInAppOpen 同口径）。
     * @param {string} key
     * @returns {string}
     */
    getUrlQueryValue: function getUrlQueryValue(key) {
      if (typeof window === 'undefined') return '';
      var values = [];
      try {
        var sp = new URLSearchParams(window.location.search || '');
        var v = sp.get(key);
        if (v) values.push(v);
      } catch (_) {}
      try {
        var hash = String(window.location.hash || '');
        var idx = hash.indexOf('?');
        if (idx >= 0) {
          var sp2 = new URLSearchParams(hash.slice(idx + 1));
          var v2 = sp2.get(key);
          if (v2) values.push(v2);
        }
      } catch (_) {}
      return values.find(Boolean) || '';
    },
    /**
     * 解析流名与展示信息：路由 params 优先，其次路由 query / URL query。
     * App 分享链接形如 `#/live/<流名>?title=..&cover=..`。
     */
    resolveRouteParams: function resolveRouteParams() {
      var _this$$route, _this$$route$params, _this$$route2, _this$$route2$params, _this$$route3, _this$$route3$query, _this$$route4, _this$$route4$query, _this$$route5, _this$$route5$query, _this$$route6, _this$$route6$query, _this$$route7, _this$$route7$query;
      var fromParams = ((_this$$route = this.$route) === null || _this$$route === void 0 ? void 0 : (_this$$route$params = _this$$route.params) === null || _this$$route$params === void 0 ? void 0 : _this$$route$params.id) || ((_this$$route2 = this.$route) === null || _this$$route2 === void 0 ? void 0 : (_this$$route2$params = _this$$route2.params) === null || _this$$route2$params === void 0 ? void 0 : _this$$route2$params.streamName);
      var fromQuery = ((_this$$route3 = this.$route) === null || _this$$route3 === void 0 ? void 0 : (_this$$route3$query = _this$$route3.query) === null || _this$$route3$query === void 0 ? void 0 : _this$$route3$query.stream_name) || ((_this$$route4 = this.$route) === null || _this$$route4 === void 0 ? void 0 : (_this$$route4$query = _this$$route4.query) === null || _this$$route4$query === void 0 ? void 0 : _this$$route4$query.streamName) || this.getUrlQueryValue('stream_name') || this.getUrlQueryValue('streamName');
      var id = (fromParams || fromQuery || '').toString().trim();
      // vue-router 的 params / query 与 URLSearchParams 都已自动解码，
      // 这里只做去空白，避免流名含 '%' 时二次解码抛错。
      this.streamName = id;
      // 主播 uid：分享链接 query 携带，透传给深链（extinfo / scheme / intent），
      // App 端直播间页用它补拉主播资料（/live/detail 不下发主播信息）。
      this.hostUserId = (((_this$$route5 = this.$route) === null || _this$$route5 === void 0 ? void 0 : (_this$$route5$query = _this$$route5.query) === null || _this$$route5$query === void 0 ? void 0 : _this$$route5$query.uid) || this.getUrlQueryValue('uid') || this.getUrlQueryValue('host_user_id') || '').toString().trim();
      this.shareTitle = (((_this$$route6 = this.$route) === null || _this$$route6 === void 0 ? void 0 : (_this$$route6$query = _this$$route6.query) === null || _this$$route6$query === void 0 ? void 0 : _this$$route6$query.title) || this.getUrlQueryValue('title') || '').toString().trim();
      this.shareCover = (((_this$$route7 = this.$route) === null || _this$$route7 === void 0 ? void 0 : (_this$$route7$query = _this$$route7.query) === null || _this$$route7$query === void 0 ? void 0 : _this$$route7$query.cover) || this.getUrlQueryValue('cover') || this.getUrlQueryValue('cover_url') || '').toString().trim();
    },
    getDownloadPageHref: function getDownloadPageHref() {
      if (typeof window === 'undefined') return '';
      var u = new URL(window.location.href);
      u.hash = '#/download';
      return u.toString();
    },
    goDownload: function goDownload() {
      navigateToDownloadPage(this.$router);
    },
    removeNativeOpenListeners: function removeNativeOpenListeners() {
      if (typeof document === 'undefined' || !this._nativeOpenHandlers) return;
      var h = this._nativeOpenHandlers;
      document.removeEventListener('visibilitychange', h.unified);
      window.removeEventListener('pagehide', h.unified);
      window.removeEventListener('blur', h.unified);
      this._nativeOpenListeners = null;
    },
    /**
     * @param {string} href
     */
    triggerDeeplinkNavigation: function triggerDeeplinkNavigation(href) {
      if (typeof window === 'undefined') return;
      try {
        var a = document.createElement('a');
        a.href = href;
        a.rel = 'nofollow noopener';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (_) {
        try {
          window.location.assign(href);
        } catch (e) {
          window.location.href = href;
        }
      }
    },
    /**
     * @param {string} schemeUrl
     */
    tryQipaoSchemeInIframe: function tryQipaoSchemeInIframe(schemeUrl) {
      if (typeof document === 'undefined') return;
      var ifr = document.createElement('iframe');
      ifr.setAttribute('aria-hidden', 'true');
      ifr.title = 'open-app';
      ifr.style.cssText = 'position:fixed;left:-9999px;width:1px;height:1px;opacity:0;pointer-events:none;';
      ifr.src = schemeUrl;
      document.body.appendChild(ifr);
      window.setTimeout(function () {
        try {
          ifr.remove();
        } catch (e) {
          if (ifr.parentNode) ifr.parentNode.removeChild(ifr);
        }
      }, 2000);
    },
    /**
     * 普通浏览器：scheme / Intent 拉起，超时未离开页面则回落下载页。
     * 微信内 JS-SDK 未就绪时也走这里兜底（自定义 scheme 多半被拦，最终仍回下载页）。
     */
    tryOpenNativeAppByDeepLink: function tryOpenNativeAppByDeepLink() {
      var _this = this;
      if (typeof window === 'undefined' || !this.streamName) return;
      showToast({
        message: '正在打开起泡…',
        duration: 2000
      });
      this.removeNativeOpenListeners();
      var isAndroid = /android/i.test(navigator.userAgent || '');
      var p = {
        streamName: this.streamName,
        uid: this.hostUserId
      };
      var fallbackUrl = this.getDownloadPageHref();
      var androidIntent = buildAndroidIntentLive(p, ANDROID_QIPAO_PACKAGE, fallbackUrl);
      var qipaoUrl = buildQipaoLiveScheme(p);
      var inWeChat = isWeChatBrowser();
      var androidFallbackMs = inWeChat ? 1800 : 2600;
      var iosFallbackMs = inWeChat ? 1500 : 2000;
      var leftPage = false;
      var onLeave = function onLeave() {
        if (leftPage) return;
        leftPage = true;
        _this.opening = false;
        _this.removeNativeOpenListeners();
      };
      var h = function h(ev) {
        if (ev && (ev.type === 'pagehide' || ev.type === 'blur')) {
          onLeave();
          return;
        }
        if (document.hidden || document.visibilityState === 'hidden') onLeave();
      };
      this._nativeOpenHandlers = {
        unified: h
      };
      document.addEventListener('visibilitychange', h, {
        passive: true
      });
      window.addEventListener('pagehide', h, {
        passive: true
      });
      window.addEventListener('blur', h, {
        passive: true
      });
      if (isAndroid) {
        this.triggerDeeplinkNavigation(androidIntent);
        window.setTimeout(function () {
          _this.tryQipaoSchemeInIframe(qipaoUrl);
        }, 200);
        window.setTimeout(function () {
          _this.removeNativeOpenListeners();
          if (!leftPage) {
            if (!inWeChat) {
              showToast({
                message: '未检测到 App，可前往下载页安装',
                duration: 2500
              });
            }
            _this.goDownload();
          }
        }, androidFallbackMs);
        return;
      }
      window.location.assign(qipaoUrl);
      window.setTimeout(function () {
        _this.removeNativeOpenListeners();
        if (!leftPage) {
          if (!inWeChat) {
            showToast({
              message: '若未自动打开，可前往 App Store 或下载页',
              duration: 2000
            });
          }
          _this.goDownload();
        }
      }, iosFallbackMs);
    },
    onOpenInApp: function onOpenInApp() {
      if (this.useWechatOpenLaunchApp) {
        showToast({
          message: '请点击底部按钮打开起泡 App',
          duration: 2000
        });
        return;
      }
      if (!this.streamName) {
        showToast('缺少直播信息');
        return;
      }
      this.opening = true;
      this.tryOpenNativeAppByDeepLink();
    }
  },
  mounted: function mounted() {
    this.resolveRouteParams();
    if (!this.streamName) {
      showToast('缺少直播信息');
    }
  },
  beforeUnmount: function beforeUnmount() {
    this.removeNativeOpenListeners();
  }
};